"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from "react";
import { CalendarClock, CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/button";
import { Spinner } from "@/shared/ui/spinner";
type ScheduledStepProps = {
  maskedPhone: string;
  graceDays: number;
};
const MOCK_DELAY_MS = 800;
export function ScheduledStep(t0) {
  const $ = _c(54);
  const {
    maskedPhone,
    graceDays
  } = t0;
  const {
    t
  } = useTranslation();
  const [isCancelling, setIsCancelling] = useState(false);
  const [cancelled, setCancelled] = useState(false);
  let t1;
  let t2;
  let t3;
  if ($[0] !== graceDays) {
    const date = new Date();
    date.setDate(date.getDate() + graceDays);
    const t4 = String(date.getDate());
    let t5;
    if ($[4] !== t4) {
      t5 = t4.padStart(2, "0");
      $[4] = t4;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    const day = t5;
    const t6 = String(date.getMonth() + 1);
    let t7;
    if ($[6] !== t6) {
      t7 = t6.padStart(2, "0");
      $[6] = t6;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    const month = t7;
    t1 = day;
    t2 = month;
    t3 = date.getFullYear();
    $[0] = graceDays;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  const deletionDate = `${t1}.${t2}.${t3}`;
  let t4;
  if ($[8] !== isCancelling) {
    t4 = async () => {
      if (isCancelling) {
        return;
      }
      setIsCancelling(true);
      await new Promise(_temp);
      setCancelled(true);
      setIsCancelling(false);
    };
    $[8] = isCancelling;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleCancel = t4;
  if (cancelled) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <CheckCircle2 className="size-10 text-emerald-600" />;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t) {
      t6 = t("landing.accountDeletion.cancelledTitle");
      $[11] = t;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== t6) {
      t7 = <h2 className="text-lg font-semibold text-slate-900">{t6}</h2>;
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== t) {
      t8 = t("landing.accountDeletion.cancelledMessage");
      $[15] = t;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== t8) {
      t9 = <p className="text-sm text-slate-600">{t8}</p>;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== t7 || $[20] !== t9) {
      t10 = <div className="mt-8 flex flex-col items-center gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-6 text-center">{t5}{t7}{t9}</div>;
      $[19] = t7;
      $[20] = t9;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    return t10;
  }
  let t5;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CalendarClock className="size-10 text-amber-600" />;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t) {
    t6 = t("landing.accountDeletion.scheduledTitle");
    $[23] = t;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t6) {
    t7 = <h2 className="text-lg font-semibold text-slate-900">{t6}</h2>;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== deletionDate || $[28] !== maskedPhone || $[29] !== t) {
    t8 = t("landing.accountDeletion.scheduledMessage", {
      phone: maskedPhone,
      date: deletionDate
    });
    $[27] = deletionDate;
    $[28] = maskedPhone;
    $[29] = t;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== t8) {
    t9 = <p className="text-sm text-slate-600">{t8}</p>;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t) {
    t10 = t("landing.accountDeletion.scheduledHint");
    $[33] = t;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== t10) {
    t11 = <p className="text-sm text-slate-500">{t10}</p>;
    $[35] = t10;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t11 || $[38] !== t7 || $[39] !== t9) {
    t12 = <div className="flex flex-col items-center gap-3 text-center">{t5}{t7}{t9}{t11}</div>;
    $[37] = t11;
    $[38] = t7;
    $[39] = t9;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== isCancelling) {
    t13 = isCancelling && <Spinner />;
    $[41] = isCancelling;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== isCancelling || $[44] !== t) {
    t14 = isCancelling ? t("landing.accountDeletion.cancelling") : t("landing.accountDeletion.cancelButton");
    $[43] = isCancelling;
    $[44] = t;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== handleCancel || $[47] !== isCancelling || $[48] !== t13 || $[49] !== t14) {
    t15 = <Button type="button" variant="outline" className="w-full" onClick={handleCancel} disabled={isCancelling}>{t13}{t14}</Button>;
    $[46] = handleCancel;
    $[47] = isCancelling;
    $[48] = t13;
    $[49] = t14;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== t12 || $[52] !== t15) {
    t16 = <div className="mt-8 flex flex-col gap-5 rounded-lg border border-amber-200 bg-amber-50 p-6">{t12}{t15}</div>;
    $[51] = t12;
    $[52] = t15;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  return t16;
}
function _temp(resolve) {
  return setTimeout(resolve, MOCK_DELAY_MS);
}